// ** Redux
import { createAsyncThunk } from "@reduxjs/toolkit";

// ** Helpers
import { createApiCall } from "helpers/createApiCall";

// ############################################################

export const setUserDataByUserpanel = createAsyncThunk(
	"globalUser/setUserDataByUserpanel",
	createApiCall(async ({ sex, ...state }, client) => {
		let data = {
			country: state.location.country,
			region: state.location.region,
			city: state.location.city,
			lang: state.lang,
			name: state.name,
			height: state.height,
			figure: state.figure,
			hair: state.hair,
			relationship: state.relationship,
			kids: state.kids,
			drink: state.drink,
			smoke: state.smoke,
			education: state.education,
			tastes: state.preferences,
			description: state.description ?? "",
			search_sex: state.search_sex,
			search_age_min: state.search_age?.from ?? null,
			search_age_max: state.search_age?.to ?? null,
			purpose: state.purpose,
		};
		if (sex === "couple") {
			data = Object.assign(data, {
				name_para: state.name_para,
				height_para: state.height_para,
				figure_para: state.figure_para,
				hair_para: state.hair_para,
				drink_para: state.drink_para,
				smoke_para: state.smoke_para,
				education_para: state.education_para,
			});
		}

		const response = await client.put("/user", data, {
			headers: {
				Accept: "application/api.1.2+json",
			},
		});
		return response.data;
	})
);

// ############################################################
